module.exports = __webpack_public_path__ + "assets/5023ea925a7fc538fb1027cd316fe98a.png";